import { apiUtils } from '../utils/apiUtils';

/**
 * The one API-call shape.
 *
 * `apiUtils` is an axios instance dressed up as fetch: it returns an object
 * carrying BOTH `.data` and a `.json()` method, and consumers split roughly
 * half-and-half between the two - one page even checked a third shape
 * (`response.success`) that only worked by accident when the payload happened
 * to carry that key through the spread.
 *
 * Everything new goes through these four functions, which return the parsed
 * body directly and throw a real Error (with the server's message) on failure.
 * The old wrapper stays until its last consumer is migrated.
 */

async function unwrap(promise) {
	const res = await promise;
	// apiUtils resolves non-2xx too (fetch semantics); normalize to throw.
	const body = res.data !== undefined ? res.data : await res.json();
	if (res.ok === false) {
		throw new Error(body?.error || body?.message || `Request failed (${res.status})`);
	}
	return body;
}

export const api = {
	get: (path, params) => unwrap(apiUtils.get(path, params ? { params } : undefined)),
	post: (path, body) => unwrap(apiUtils.post(path, body)),
	put: (path, body) => unwrap(apiUtils.put(path, body)),
	del: (path) => unwrap(apiUtils.delete(path)),
};

export default api;
